import { NgModule, Inject, Optional } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsRootModule } from './effects_root_module';
import { FEATURE_EFFECTS } from './tokens';
export class EffectsFeatureModule {
/**
 * @param {?} root
 * @param {?} effectSourceGroups
 * @param {?} storeModule
 */
constructor(
private root: EffectsRootModule,
     effectSourceGroups: any[][],
     storeModule: StoreModule
  ) {
    effectSourceGroups.forEach(group =>
      group.forEach(effectSourceInstance =>
        root.addEffects(effectSourceInstance)
      )
    );
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: EffectsRootModule, },
{type: Array, decorators: [{ type: Inject, args: [FEATURE_EFFECTS, ] }, ]},
{type: StoreModule, decorators: [{ type: Optional }, ]},
];
}

function EffectsFeatureModule_tsickle_Closure_declarations() {
/** @type {?} */
EffectsFeatureModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
EffectsFeatureModule.ctorParameters;
/** @type {?} */
EffectsFeatureModule.prototype.root;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../modules/effects/src/effects_feature_module.ts